import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4bc95b32"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "fulfillment" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", null, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-circle ml-2 mr-2" }),
    /*#__PURE__*/ _createTextVNode("We are not able to provide automated tracking updates for this application")
], -1));
const _hoisted_4 = [
    _hoisted_3
];
const _hoisted_5 = { key: 1 };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paper-plane ml-2 mr-2" }, null, -1));
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "fax", -1));
const _hoisted_8 = { class: "mt-3" };
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock ml-2 mr-2" }, null, -1));
const _hoisted_10 = { key: 2 };
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paper-plane ml-2 mr-2" }, null, -1));
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "manually", -1));
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", { class: "mt-3" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-circle ml-2 mr-2" }),
    /*#__PURE__*/ _createTextVNode("We are not able to provide tracking updates for this application.")
], -1));
const _hoisted_14 = { key: 3 };
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paper-plane ml-2 mr-2" }, null, -1));
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "online", -1));
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", { class: "mt-3" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-exclamation-circle ml-2 mr-2" }),
    /*#__PURE__*/ _createTextVNode("We are not able to provide tracking updates for this application here.")
], -1));
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("li", { class: "mt-3" }, [
    /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-info-circle ml-2 mr-2" }),
    /*#__PURE__*/ _createTextVNode("You may be able to obtain more information its status by checking the relevant online portal.")
], -1));
const _hoisted_19 = { key: 4 };
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paper-plane ml-2 mr-2" }, null, -1));
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "virtual mail", -1));
const _hoisted_22 = { class: "mt-3" };
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock ml-2 mr-2" }, null, -1));
const _hoisted_24 = { class: "mt-3" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-tag ml-2 mr-2" }, null, -1));
const _hoisted_26 = ["href"];
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt" }, null, -1));
const _hoisted_28 = { key: 1 };
const _hoisted_29 = { key: 5 };
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-paper-plane ml-2 mr-2" }, null, -1));
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("strong", null, "shipping label", -1));
const _hoisted_32 = { class: "mt-3" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-clock ml-2 mr-2" }, null, -1));
const _hoisted_34 = { class: "mt-3" };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-tag ml-2 mr-2" }, null, -1));
const _hoisted_36 = ["href"];
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "fas fa-external-link-alt" }, null, -1));
const _hoisted_38 = { key: 1 };
import { formatDateTime } from "@/core/utils";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationFulfillmentTracker',
    props: {
        fulfillment: {}
    },
    setup(__props) {
        const props = __props;
        const formatStatus = (fulfillment) => {
            switch (fulfillment.status) {
                case "QUEUED": return "Pending";
                case "SENT": return "Sent";
                case "DELIVERED": return "Delivered";
                case "DELIVERY_FAILED": return "Delivery Failed";
                case "SENDING_FAILED": return "Sending Failed";
                case "UNKNOWN": return "Unknown";
                default: return fulfillment.status;
            }
        };
        const formatTrackingNumber = (fulfillment) => {
            switch (fulfillment.method) {
                case "FAX": return "";
                case "LETTER": return `${fulfillment.trackingNumber} (USPS)`;
                case "ONLINE": return "";
                case "MANUAL": return "";
                case "SHIPPING_LABEL": return `${fulfillment.trackingNumber.split(':')[1]} (USPS)`;
            }
        };
        const generateTrackingLink = (fulfillment) => {
            switch (fulfillment.method) {
                case "FAX": return "";
                case "LETTER": return `https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=${fulfillment.trackingNumber}`;
                case "ONLINE": return "";
                case "MANUAL": return "";
                case "SHIPPING_LABEL": return `https://tools.usps.com/go/TrackConfirmAction_input?strOrigTrackNum=${fulfillment.trackingNumber.split(':')[1]}`;
            }
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (!_ctx.fulfillment)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_2, _hoisted_4))
                    : (_ctx.fulfillment.method == 'FAX')
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                            _createElementVNode("li", null, [
                                _hoisted_6,
                                _createTextVNode("This application was submitted via "),
                                _hoisted_7,
                                _createTextVNode(" on: " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.createdAt)), 1)
                            ]),
                            _createElementVNode("li", _hoisted_8, [
                                _hoisted_9,
                                _createTextVNode("Its current status is: "),
                                _createElementVNode("strong", null, _toDisplayString(formatStatus(_ctx.fulfillment)), 1),
                                _createTextVNode(" (updated " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.lastModifiedAt)) + ")", 1)
                            ])
                        ]))
                        : (_ctx.fulfillment.method == 'MANUAL')
                            ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                                _createElementVNode("li", null, [
                                    _hoisted_11,
                                    _createTextVNode("This application was submitted "),
                                    _hoisted_12,
                                    _createTextVNode(" on: " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.createdAt)), 1)
                                ]),
                                _hoisted_13
                            ]))
                            : (_ctx.fulfillment.method == 'ONLINE')
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
                                    _createElementVNode("li", null, [
                                        _hoisted_15,
                                        _createTextVNode("This application was submitted "),
                                        _hoisted_16,
                                        _createTextVNode(" on: " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.createdAt)), 1)
                                    ]),
                                    _hoisted_17,
                                    _hoisted_18
                                ]))
                                : (_ctx.fulfillment.method == 'LETTER')
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_19, [
                                        _createElementVNode("li", null, [
                                            _hoisted_20,
                                            _createTextVNode("This application was submitted by "),
                                            _hoisted_21,
                                            _createTextVNode(" on: " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.createdAt)), 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_22, [
                                            _hoisted_23,
                                            _createTextVNode("Its current status is: "),
                                            _createElementVNode("strong", null, _toDisplayString(formatStatus(_ctx.fulfillment)), 1),
                                            _createTextVNode(" (updated " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.lastModifiedAt)) + ")", 1)
                                        ]),
                                        _createElementVNode("li", _hoisted_24, [
                                            _hoisted_25,
                                            _createTextVNode("Tracking link: "),
                                            (_ctx.fulfillment.trackingNumber)
                                                ? (_openBlock(), _createElementBlock("a", {
                                                    key: 0,
                                                    href: generateTrackingLink(_ctx.fulfillment),
                                                    target: "_blank"
                                                }, [
                                                    _createTextVNode(_toDisplayString(formatTrackingNumber(_ctx.fulfillment)) + " ", 1),
                                                    _hoisted_27
                                                ], 8, _hoisted_26))
                                                : (_openBlock(), _createElementBlock("em", _hoisted_28, "Not yet available"))
                                        ])
                                    ]))
                                    : (_ctx.fulfillment.method == 'SHIPPING_LABEL')
                                        ? (_openBlock(), _createElementBlock("ul", _hoisted_29, [
                                            _createElementVNode("li", null, [
                                                _hoisted_30,
                                                _createTextVNode("A "),
                                                _hoisted_31,
                                                _createTextVNode(" for this application was generated on: " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.createdAt)), 1)
                                            ]),
                                            _createElementVNode("li", _hoisted_32, [
                                                _hoisted_33,
                                                _createTextVNode("Its current status is: "),
                                                _createElementVNode("strong", null, _toDisplayString(formatStatus(_ctx.fulfillment)), 1),
                                                _createTextVNode(" (updated " + _toDisplayString(_unref(formatDateTime)(_ctx.fulfillment.lastModifiedAt)) + ")", 1)
                                            ]),
                                            _createElementVNode("li", _hoisted_34, [
                                                _hoisted_35,
                                                _createTextVNode("Tracking link: "),
                                                (_ctx.fulfillment.trackingNumber)
                                                    ? (_openBlock(), _createElementBlock("a", {
                                                        key: 0,
                                                        href: generateTrackingLink(_ctx.fulfillment),
                                                        target: "_blank"
                                                    }, [
                                                        _createTextVNode(_toDisplayString(formatTrackingNumber(_ctx.fulfillment)) + " ", 1),
                                                        _hoisted_37
                                                    ], 8, _hoisted_36))
                                                    : (_openBlock(), _createElementBlock("em", _hoisted_38, "Not yet available"))
                                            ])
                                        ]))
                                        : _createCommentVNode("", true)
            ]));
        };
    }
});
